export default {"src":"/_next/static/media/quate.b319e599.svg","height":44,"width":44};